import { render } from "./ExpiresCard.vue?vue&type=template&id=13e24864&scoped=true&ts=true"
import script from "./ExpiresCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpiresCard.vue?vue&type=script&setup=true&lang=ts"

import "./ExpiresCard.vue?vue&type=style&index=0&id=13e24864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e24864"],['__file',"src/components/ExpiresCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13e24864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13e24864', __exports__)) {
    api.reload('13e24864', __exports__)
  }
  
  module.hot.accept("./ExpiresCard.vue?vue&type=template&id=13e24864&scoped=true&ts=true", () => {
    api.rerender('13e24864', render)
  })

}


export default __exports__